import React from 'react'
import AboutYou from '../../../features/CandProfCreation/CandidateProfileSlice/AboutYou/AboutYou'

function AboutPage() {
  return (
    <div>
      <AboutYou />
    </div>
  )
}

export default AboutPage
